import {MiscI18n} from '@/locales/base.message.locales';

export const misc: MiscI18n = {
  days: 'dias',
  hours: 'horas',
  minutes: 'min',
  seconds: 'seg',
};
